import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Image from "./imgs/image.jpg"; // Importing the image for use
import confetti from "canvas-confetti";

function App() {
  // Adiciona estado para o timer
  const [timeLeft, setTimeLeft] = useState(30 * 60); // 30 minutos em segundos

  // Número aleatório de pessoas entre 3000 e 4000
  const [peopleCount] = useState(
    () => Math.floor(Math.random() * (4000 - 3000 + 1)) + 3000
  );

  // Estado para controlar o fade-in do botão
  const [showButton, setShowButton] = useState(false);

  // Estado para controlar o fade-in da imagem
  const [showImage, setShowImage] = useState(false);

  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);

  useEffect(() => {
    // Exibe o botão após um pequeno delay para o fade-in
    const timeout = setTimeout(() => setShowButton(true), 300);
    // Exibe a imagem com animação após um pequeno delay
    const imgTimeout = setTimeout(() => setShowImage(true), 200);
    return () => {
      clearTimeout(timeout);
      clearTimeout(imgTimeout);
    };
  }, []);

  useEffect(() => {
    // Animação de confete ao carregar a página
    confetti({
      particleCount: 80,
      spread: 80,
      origin: { y: 0.5 },
      startVelocity: 50,
      zIndex: 9999,
    });
  }, []);

  // Função para formatar o tempo em mm:ss
  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  // Função para redirecionar ao clicar no botão
  const handleRedirect = () => {
    window.location.href = "https://bankerhub.io/5/alfa/27913";
  };

  return (
    <div
      className="text-center text-white d-flex flex-column justify-content-center align-items-center"
      style={{
        minHeight: "100vh",
        backgroundImage:
          "radial-gradient(at top center, #133076 0%, #010A25 71%)",
        padding: "2rem",
      }}
    >
      <h1 className="fw-bold mb-3">BILHETE LIBERADO!</h1>

      <div className="mb-2 ">
        <button className="btnpeople btn btn-outline-light rounded-pill  fw-bold text-nowrap">
          <i className="bi bi-people me-2" />
          {peopleCount} pessoas já apostaram nesse bilhete
        </button>
      </div>

      <div className="mb-4">
        <button className="btn btn-danger fw-bold rounded-pill px-4 py-2">
          <i className="bi bi-clock me-2" />O bilhete expira em{" "}
          <span>{formatTime(timeLeft)}</span>
        </button>
      </div>

      <div
        className=" text-dark rounded shadow p-4 mb-4"
        style={{ maxWidth: "400px", width: "100%" }}
      >
        <img
          src={Image}
          alt="Bilhete"
          className={`img-fluid rounded mb-3 animated-img-center`}
          style={{
            opacity: showImage ? 1 : 0,
            transform: showImage ? "scale(1)" : "scale(0.95)",
            transition:
              "opacity 0.8s ease, transform 0.8s cubic-bezier(.4,2,.6,1)",
          }}
        />
      </div>

      <button
        className="btn fw-bold text-white fade-in-bilhete animated-btn-gradient"
        style={{
          width: "100%",
          maxWidth: "400px",
          minWidth: "180px",
          padding: "0.8rem 2rem",
          borderRadius: "2rem",
          opacity: showButton ? 1 : 0,
          transition: "opacity 1s ease",
        }}
        onClick={handleRedirect}
        type="button"
      >
        PEGAR O BILHETE AGORA
      </button>

      <footer
        className=" small w-100"
        style={{
          borderTop: "2px solid #505669",
          marginTop: "2rem",
          paddingTop: "1rem",
          color: "white",
        }}
      >
        +18 JOGUE COM RESPONSABILIDADE
      </footer>
      <style>
        {`
          @media (min-width: 992px) {
            .animated-btn-gradient {
              width: 30% !important;
              min-width: 180px;
              max-width: 400px;
            }
          }
        `}
      </style>
    </div>
  );
}

export default App;
